// extracted by mini-css-extract-plugin
export var activeDot = "_2h-c";
export var buttonContainer = "_2h-9";
export var channelButton = "_2h-a";
export var clickable = "_2h-d";
export var content = "_2h-0";
export var contentFull = "_2h-2";
export var contentThird = "_2h-1";
export var contentWrapper = "_2h-7";
export var description = "_2h-5";
export var heightShort = "_2h-f";
export var image = "_2h-3";
export var imageContainer = "_2h-4";
export var selectButton = "_2h-e";
export var spinnerContainer = "_2h-b";
export var titleContent = "_2h-8";
export var titleWrapper = "_2h-6";